 <!-- 保税核注 -->
 <template>
    <div>
        <!-- 报关单功能键 -->
        <div class="top_flex">
            <div>
                <el-button type="primary" icon="el-icon-document-remove" size="mini" @click="temporarilySave(true)"
                :disabled="(invtHeadType.id !== '' && invtHeadType.seqNo !== '')?true:false">暂存</el-button>
                <el-button type="primary" icon="el-icon-document-checked" size="mini" @click="temporarilySave(false)"
                :disabled="(invtHeadType.id !== '' && invtHeadType.seqNo !== '')?true:false">提交复审</el-button>
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="copyDeclare(false)">新建</el-button>
                <el-button type="primary" icon="el-icon-copy-document" size="mini" @click="copyDeclare(true)">复制</el-button>
                <el-button type="primary" icon="el-icon-printer" size="mini" @click="report">打印</el-button>
                <el-button type="primary" icon="el-icon-delete" size="mini" :disabled="(invtHeadType.id !== '' && !invtHeadType.checker)?false:true" @click="deleteInvInfo" >删除</el-button>
                <!-- <el-button type="primary" icon="el-icon-download" size="mini">导入</el-button> -->
                <span style="margin-left: 20px;"></span>
                <el-button type="primary" icon="el-icon-upload" size="mini" @click="declareInvt"
                :disabled="(invtHeadType.id !== '' && invtHeadType.seqNo !== '')?true:false">申报</el-button>

                <span class="nameInput">初审人: {{ invtHeadType.inputerName?invtHeadType.inputerName:localStorageName }}</span>
                <span class="nameInput">复审人: {{ invtHeadType.checker?invtHeadType.checker:'' }}</span>
            </div>
            <!-- <el-button type="primary" icon="el-icon-upload" size="mini" @click="declareInvt">申报</el-button> -->
        </div>
        <el-tabs type="border-card" class="margin_top_10">
            <el-tab-pane label="表头">
                 <el-form class="form_declare" :model="invtHeadType" ref="invtHeadType" label-width="242px" size="mini" :rules="invtHeadTypeRules">
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="预录入统一编号	" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="清单编号" label-width="140px" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="清单类型" label-width="140px" prop="invtType">
                                <el-select ref="invtTypeText" class="width_100 yellow" filterable :default-first-option="true" v-model="invtHeadType.invtType" placeholder="请选择清单类型">
                                    <el-option v-for="item in billTYPE"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="账册编号" prop="putrecNo">
                                <el-input class="yellow" v-model="invtHeadType.putrecNo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="经营单位编码" prop="bizopEtpsNo">
                                <el-input class="yellow" v-model="invtHeadType.bizopEtpsNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="经营单位社会信用代码" label-width="140px">
                                <el-input v-model="invtHeadType.bizopEtpsSccd"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="经营单位名称" prop="bizopEtpsNm">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                @change="enterpriseChange($event,'bizopEtpsNm')" placeholder="请选择经营单位" v-model="invtHeadType.bizopEtpsNm"
                                @blur="selectBlur($event,'bizopEtpsNm')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="加工单位编码" prop="rcvgdEtpsNo">
                                <el-input class="yellow" v-model="invtHeadType.rcvgdEtpsNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="加工单位社会信用代码" label-width="140px" >
                                <el-input v-model="invtHeadType.rvsngdEtpsSccd" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="加工单位名称" prop="rcvgdEtpsNm">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                @change="enterpriseChange($event,'rcvgdEtpsNm')" placeholder="请选择加工单位" v-model="invtHeadType.rcvgdEtpsNm"
                                @blur="selectBlur($event,'rcvgdEtpsNm')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="申报单位编码" prop="dclEtpsNo">
                                <el-input v-model="invtHeadType.dclEtpsNo" class="yellow"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="申报单位社会信用代码" label-width="140px" >
                                <el-input v-model="invtHeadType.dclEtpsSccd" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="申报单位名称" prop="dclEtpsNm">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                @change="enterpriseChange($event,'dclEtpsNm')" placeholder="请选择加工单位" v-model="invtHeadType.dclEtpsNm"
                                @blur="selectBlur($event,'dclEtpsNm')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="录入单位编码" >
                                <el-input :disabled="true" v-model="invtHeadType.inputCode" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="录入单位社会信用代码" label-width="140px" >
                                <el-input :disabled="true" v-model="invtHeadType.inputCreditCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="录入单位名称" >
                                <el-input :disabled="true" v-model="invtHeadType.inputName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="企业内部编号" prop="etpsInnerInvtNo">
                                <el-input class="yellow " v-model="invtHeadType.etpsInnerInvtNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="申报类型" label-width="140px" >
                                <el-select class="width_100 " v-model="invtHeadType.dclTypecd" :disabled="true" placeholder="">
                                    <el-option v-for="item in declareTYPE" :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="录入日期" label-width="140px" >
                                <el-select class="width_100" v-model="invtHeadType.inputTime" :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="清单申报日期" >
                                <el-input :disabled="true" v-model="invtHeadType.invtDclTime"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="料件、成品标志" prop="mtpckEndprdMarkcd"> 
                                <el-select ref="mtpckEndprdMarkcdText" class="width_100 yellow" filterable :default-first-option="true" v-model="invtHeadType.mtpckEndprdMarkcd" placeholder="请选择料件、成品标志">
                                    <el-option v-for="item in mtpckEndprdTYPE" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="监管方式" label-width="140px" prop="supvModecd">
                                <el-select ref="supvModecdText" class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择监管方式" v-model="invtHeadType.supvModecd">
                                    <el-option v-for="item in superviseList" :key="item.cusCode" :label="item.cusCode + ' - ' + item.codeName" :value="item.cusCode">
                                        <span class="margin_right_20">{{ item.cusCode }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="运输方式" prop="trspModecd">
                                <el-select ref="trspModecdText" class="width_100 yellow" filterable  placeholder="请选择运输方式" v-model="invtHeadType.trspModecd" :default-first-option="true">
                                    <el-option v-for="item in transportModeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item :label="exportCode === 'I'? '进境关别' : '出境关别'"  prop="impexpPortcd">
                                <el-select ref="impexpPortcdText" class="width_100 yellow" remote :remote-method="getCustomsList" filterable :default-first-option="true"
                                v-model="invtHeadType.impexpPortcd" @change="emptyList($event,'impexpPortcd')" @focus="getCustomsList(invtHeadType.impexpPortcd)"
                                :placeholder="exportCode==='E'?'请选择出境关别':'请选择进境关别'">
                                    <el-option v-for="item in customsList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " 
                                    :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="主管海关" label-width="140px" prop="dclPlcCuscd">
                                <el-select ref="dclPlcCuscdText" class="width_100 yellow" remote :remote-method="getCustomsList" filterable :default-first-option="true"
                                v-model="invtHeadType.dclPlcCuscd" @change="emptyList($event,'dclPlcCuscd')" @focus="getCustomsList(invtHeadType.dclPlcCuscd)"
                                placeholder="请选择主管海关">
                                    <el-option v-for="item in customsList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " 
                                    :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="核扣标志" label-width="140px" >
                                <el-select class="width_100" v-model="invtHeadType.vrfdedMarkcd" :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item :label="exportCode === 'I' ? '启运国(地区)':'运抵国(地区)'" prop="stshipTrsarvNatcd">
                                <el-select ref="stshipTrsarvNatcdText" class="width_100 yellow" filterable :default-first-option="true" remote :remote-method="getCountryList" 
                                v-model="invtHeadType.stshipTrsarvNatcd" @focus="getCountryList(invtHeadType.stshipTrsarvNatcd)" @change="emptyList($event,'stshipTrsarvNatcd')"
                                :placeholder="exportCode==='E'?'请选择运抵国(地区)':'请选择启运国(地区)'">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.cusCode">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="清单进出卡口状态" >
                                <el-input v-model="invtHeadType.invtIochkptStucd" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="申报表编号" label-width="140px" >
                                <el-input v-model="invtHeadType.applyNo" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="流转类型" >
                                <el-select ref="listTypeText" class="width_100" filterable :default-first-option="true" v-model="invtHeadType.listType" placeholder="请选择流转类型">
                                    <el-option v-for="item in listTypeList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="报关标志" prop="dclcusFlag">
                                <el-select ref="dclcusFlagText" class="width_100 yellow" filterable :default-first-option="true" v-model="invtHeadType.dclcusFlag" placeholder="请选择报关标志">
                                    <el-option v-for="item in dclcusFlagList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5"> 
                            <el-form-item label="是否系统生成报关单" prop="genDecFlag" label-width="140px" >
                                <el-select class="width_100 yellow" filterable :default-first-option="true" v-model="invtHeadType.genDecFlag" placeholder="请选择是否系统生成报关单">
                                    <el-option v-for="item in gendecFlagList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="报关单类型" label-width="140px" >
                                <el-select ref="decTypeText" class="width_100" filterable :default-first-option="true" v-model="invtHeadType.decType" placeholder="请选择报关单类型">
                                    <el-option v-for="item in decTypeList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="报关类型" :prop="invtHeadType.dclcusFlag === '1'?'dclcusTypecd':''"> 
                                <el-select ref="dclcusTypecdText" class="width_100" filterable :default-first-option="true" v-model="invtHeadType.dclcusTypecd" placeholder="请选择报关类型"
                                @change="dclcusTypecdSelect">
                                    <el-option v-for="item in dclcusTypeList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="对应报关单编号" >
                                <el-input :disabled="true" v-model="invtHeadType.entryNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="对应报关单申报单位编码" label-width="140px" >
                                <el-input :disabled="invtHeadType.dclcusTypecd === '1'?true:false" v-model="invtHeadType.corrEntryDclEtpsNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="对应报关单申报单位社会信用代码" >
                                <el-input :disabled="invtHeadType.dclcusTypecd === '1'?true:false" v-model="invtHeadType.corrEntryDclEtpsSccd"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label="对应报关单申报单位名称" >
                                <el-input :disabled="invtHeadType.dclcusTypecd === '1'?true:false" v-model="invtHeadType.corrEntryDclEtpsNm"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="关联报关单编号" >
                                <el-input :disabled="true" v-model="invtHeadType.rltEntryNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="关联清单编号"  >
                                <el-input :disabled="exportCode === 'I' ? true:false " v-model="invtHeadType.rltInvtNo" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="关联手(账)册备案号" >
                                <el-input v-model="invtHeadType.rltPutrecNo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="关联报关单境内收发货人编码" :prop="invtHeadType.dclcusTypecd === '1'?'rltEntryBizopEtpsno':''">
                                <el-input :disabled="invtHeadType.dclcusTypecd === '2'?true:false" v-model="invtHeadType.rltEntryBizopEtpsno"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="关联报关单境内收发货人社会信用代码" >
                                <el-input :disabled="invtHeadType.dclcusTypecd === '2'?true:false" v-model="invtHeadType.rltEntryBizopEtpsSccd"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="关联报关单境内收发货人名称" :prop="invtHeadType.dclcusTypecd === '1'?'rltEntryBizopEtpsNm':''">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                :disabled="invtHeadType.dclcusTypecd ==='2'?true:false"
                                @change="enterpriseChange($event,'rltEntryBizopEtpsNm')" placeholder="请选择关联报关单境内收发货人" v-model="invtHeadType.rltEntryBizopEtpsNm"
                                @blur="selectBlur($event,'rltEntryBizopEtpsNm')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="关联报关单生产销售(消费使用)单位编码" :prop="invtHeadType.dclcusTypecd === '1'?'rltEntryRcvgdEtpsno':''">
                                <el-input :disabled="invtHeadType.dclcusTypecd ==='2'?true:false" v-model="invtHeadType.rltEntryRcvgdEtpsno"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="关联报关单生产销售(消费使用)社会信用代码"  >
                                <el-input :disabled="invtHeadType.dclcusTypecd ==='2'?true:false" v-model="invtHeadType.rltEntryRvsngdEtpsSccd" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="关联报关单生产销售(消费使用)单位名称" :prop="invtHeadType.dclcusTypecd === '1'?'rltEntryRcvgdEtpsNm':''">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                :disabled="invtHeadType.dclcusTypecd ==='2'?true:false"
                                @change="enterpriseChange($event,'rltEntryRcvgdEtpsNm')" placeholder="请选择关联报关单生产销售(消费使用)单位" v-model="invtHeadType.rltEntryRcvgdEtpsNm"
                                @blur="selectBlur($event,'rltEntryRcvgdEtpsNm')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="关联报关单申报单位编码" :prop="invtHeadType.dclcusTypecd === '1'?'rltEntryDclEtpsno':''">
                                <el-input :disabled="invtHeadType.dclcusTypecd ==='2'?true:false" v-model="invtHeadType.rltEntryDclEtpsno" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="关联报关单申报单位社会信用代码" >
                                <el-input :disabled="invtHeadType.dclcusTypecd ==='2'?true:false" v-model="invtHeadType.rltEntryDclEtpsSccd"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="关联报关单申报单位名称" :prop="invtHeadType.dclcusTypecd === '1'?'rltEntryDclEtpsNm':''">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                :disabled="invtHeadType.dclcusTypecd ==='2'?true:false"
                                @change="enterpriseChange($event,'rltEntryDclEtpsNm')" placeholder="请选择关联报关单生产销售(消费使用)单位" v-model="invtHeadType.rltEntryDclEtpsNm"
                                @blur="selectBlur($event,'rltEntryDclEtpsNm')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="报关单申报日期" >
                                <el-input :disabled="true" v-model="invtHeadType.entryDclTime"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="17">
                            <el-form-item label="备注"  >
                                <el-input v-model="invtHeadType.rmk"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="报关单统一编号" >
                                <el-input :disabled="true" v-model="invtHeadType.seqNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="17">
                            <el-form-item label="报关单草稿(备注)"  >
                                <el-input   v-model="invtHeadType.decRmk"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="7">
                            <el-form-item label="操作员卡号" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="17">
                            <el-form-item label="核销标志"  >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="表体">
                <el-form class="form_declare" ref="invtListType" :model="invtListType" label-width="120px" size="mini" :rules="invtListTypeRules">
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="序号" >
                                <el-input  :disabled="true" v-model="invtListType.gdsSeqNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="备案序号">
                                <el-input  v-model="invtListType.putrecSeqNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品料号" prop="gdsMtNo">
                                <el-input class="yellow" v-model="invtListType.gdsMtNo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="报关单商品序号" >
                                <el-input v-model="invtListType.entryGdsSeqNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="申报表序号">
                                <el-input  v-model="invtListType.applyTbSeqno"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品编码" prop="gdeCd" >
                                <el-input class="yellow" @keyup.enter.native="goodsCodeEnter" v-model="invtListType.gdeCd"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="商品名称" prop="gdsNm">
                                <el-input class="yellow" v-model="invtListType.gdsNm"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="规格型号" prop="gdsSpcfModelDesc">
                                <el-input class="yellow" v-model="invtListType.gdsSpcfModelDesc"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="币制" prop="dclCurr">
                                <el-select class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择币制" 
                                    v-model="invtListType.dclCurr">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.cusCode">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="申报计量单位" prop="dclUnit">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getUnitList" :default-first-option="true" 
                                v-model="invtListType.dclUnit" placeholder="请选择申报计量单位" @change="emptyList($event,'dclUnit')" @focus="getUnitList(invtListType.dclUnit)">
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="法定计量单位">
                                <el-select class="width_100 " v-model="invtListType.lawfUnit" :disabled="true" placeholder=" ">
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="法定第二计量单位" >
                                <el-select class="width_100 " v-model="invtListType.secdLawfUnit" :disabled="true" placeholder=" ">
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="申报数量" prop="dclUnitQty">
                                <el-input class="yellow" v-model="invtListType.dclUnitQty" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="法定数量" prop="lawfUnitQty">
                                <el-input class="yellow" v-model="invtListType.lawfUnitQty" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="第二法定数量" >
                                <el-input v-model="invtListType.secdLawfUnitQty" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="申报单价" prop="dclUprcAmt">
                                <el-input class="yellow" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" v-model="invtListType.dclUprcAmt"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="申报总价" prop="dclTotalAmt"> 
                                <el-input class="yellow" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" v-model="invtListType.dclTotalAmt"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="原产国(地区)" prop="natcd">
                                <el-select class="width_100 yellow" filterable remote :remote-method="getCountryList" 
                                placeholder="请选择原产国（地区）" v-model="invtListType.natcd" @change="emptyList($event,'natcd')" 
                                :default-first-option="true" @focus="getCountryList(invtListType.natcd)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.cusCode">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span>  
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="重量比例因子" >
                                <el-input  :disabled="true" v-model="invtListType.wtSfval"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="第一比例因子">
                                <el-input  :disabled="true" v-model="invtListType.fstSfval"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="第二比例因子" >
                                <el-input :disabled="true" v-model="invtListType.secdSfval"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="毛重" >
                                <el-input v-model="invtListType.grossWt"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="净重">
                                <el-input v-model="invtListType.netWt"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="最终目的国(地区)" prop="destinationNat" >
                                <el-select class="width_100 yellow" filterable remote :remote-method="getCountryList" 
                                placeholder="请选择最终目的国（地区）" v-model="invtListType.destinationNat" @change="emptyList($event,'destinationNat')" 
                                :default-first-option="true" @focus="getCountryList(invtListType.destinationNat)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.cusCode">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span>  
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="征免方式" prop="lvyrlfModecd">
                                <el-select class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择征免方式" 
                                    v-model="invtListType.lvyrlfModecd">
                                    <el-option v-for="item in dutyModeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="单耗版本号">
                                <el-input v-model="invtListType.ucnsVemo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="自动备案序号" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="修改标志" >
                                <el-select :disabled="true"  class="width_100" filterable :default-first-option="true" placeholder="" v-model="invtListType.modfMark">
                                    <el-option v-for="item in modfMarkcdList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="危化品标志" prop="clyMark">
                                <el-select clearable  class="width_100" filterable :default-first-option="true" placeholder="" v-model="invtListType.clyMark">
                                    <el-option v-for="item in trueORfalse" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="来源标识" >
                                <el-input :disabled="true" v-model="invtListType.param1"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label="备注" >
                                <el-input  v-model="invtListType.rmk" @keyup.enter.native="addGoosdList"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 表体汇总 -->
                <div class="summaryText">
                <i class="el-icon-s-data" style="margin-right: 5px;"></i>
                    表体汇总： 申报总价 = <span class="margin_5">{{tipsTotal.dclTotalAmt}}</span> 申报数量 = <span class="margin_5">{{tipsTotal.dclUnitQty}}</span> 法定数量 = <span class="margin_5">{{tipsTotal.lawfUnitQty}}</span> 
                    法定第二数量 = <span class="margin_5">{{tipsTotal.secdLawfUnit}}</span class="margin_5"> 毛重= <span class="margin_5">{{tipsTotal.grossWt}}</span> 净重= <span class="margin_5">{{tipsTotal.netWt}}</span>
                </div>
                <!-- 功能键 -->
                <div class="top_flex">
                    <div>
                        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addGoodsList">新增</el-button>
                        <el-button type="primary" icon="el-icon-delete" size="mini" @click="deleteGoodsDetails">删除</el-button>
                        <el-button type="primary" icon="el-icon-copy-document" size="mini" @click="copyGoods">复制</el-button>
                        <el-button type="primary" icon="el-icon-upload2" size="mini" >导出</el-button>
                        <el-button type="primary" icon="el-icon-search" size="mini" >商品快速查询</el-button>
                    </div>
                </div>
                <!-- 商品表格 -->
                <el-table style="width: 100%;" size="mini" height="200px" highlight-current-row  :header-cell-style="{'text-align':'center'}"
                ref="invtList" :data="invtList" @current-change="goodsDetailsShow">
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column label="序号" prop="gdsSeqNo" width="50" > </el-table-column>
                    <el-table-column label="备案序号" prop="putrecSeqNo" width="80" align="center"> </el-table-column>
                    <el-table-column label="商品料号" prop="gdsMtNo" width="120"  align="center"> </el-table-column>
                    <el-table-column label="报关单商品序号" prop="entryGdsSeqNo" width="120"  align="center"> </el-table-column>
                    <el-table-column label="申报表序号" prop="applyTbSeqno" align="center"> </el-table-column>
                    <el-table-column label="商品编码" prop="gdeCd" align="center" width="100"> </el-table-column>
                    <el-table-column label="商品名称" prop="gdsNm" align="center"  width="120"> </el-table-column>
                    <el-table-column label="规格型号" prop="gdsSpcfModelDesc" align="center" width="200"> 
                         <template slot-scope="scope">
                            <span class="omitText"> {{ scope.row.gdsSpcfModelDesc }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="原产国(地区)" prop="natcd" width="120" align="center"> </el-table-column>
                    <el-table-column label="最终目的国(地区)" prop="destinationNat" width="120" align="center"> </el-table-column>
                    <el-table-column label="申报计量单位" prop="dclUnit" width="120" align="center"> </el-table-column>
                    <el-table-column label="申报数量" prop="dclUnitQty" align="center"> </el-table-column>
                    <el-table-column label="申报单价" prop="dclUprcAmt" align="center"> </el-table-column>
                    <el-table-column label="申报总价" prop="dclTotalAmt" align="center"> </el-table-column>
                    <el-table-column label="币制" prop="dclCurr" align="center"> </el-table-column>
                    <el-table-column label="修改标志" prop="modfMark" align="center"> </el-table-column>
                    <el-table-column label="法定计量单位" prop="lawfUnit" width="120" align="center"> </el-table-column>
                    <el-table-column label="法定第二计量单位" prop="secdLawfUnit" width="120" align="center"> </el-table-column>
                    <el-table-column label="法定数量" prop="lawfUnitQty" align="center"> </el-table-column>
                    <el-table-column label="第二法定数量" prop="secdLawfUnitQty" width="120" align="center"> </el-table-column>
                    <el-table-column label="重量比例因子" prop="wtSfval" width="120" align="center"> </el-table-column>
                    <el-table-column label="第一比例因子" prop="fstSfval" width="120" align="center"> </el-table-column>
                    <el-table-column label="第二比例因子" prop="secdSfval" width="120" align="center"> </el-table-column>
                    <el-table-column label="毛重" prop="grossWt" align="center"> </el-table-column>
                    <el-table-column label="净重" prop="netWt" align="center"> </el-table-column>
                    <el-table-column label="征免方式" prop="lvyrlfModecd" align="center"> </el-table-column>
                    <el-table-column label="单耗版本号" prop="ucnsVemo" align="center"> </el-table-column>
                    <el-table-column label="自动备案序号" width="120" align="center"> </el-table-column>
                    <el-table-column label="危化品标志" prop="clyMark" align="center"> </el-table-column>
                    <el-table-column label="来源标识" prop="param1" align="center"> </el-table-column>
                </el-table>
                <el-divider content-position="left"><span>报关单草稿</span>  重要提示：登录 货物申报系统 ，进入 货物申报 - 综合查询 下点击查询界面，输入报关单统一编号“点击查询”即可调出报关单数据。</el-divider>
                <el-table style="width: 100%;" size="mini" height="200px" highlight-current-row  :header-cell-style="{'text-align':'center'}">
                    <el-table-column label="报关单统一编号" width="120"> </el-table-column>
                    <el-table-column label="报关单商品序号" width="120" align="center"> </el-table-column>
                    <el-table-column label="商品编码" width="80"  align="center"> </el-table-column>
                    <el-table-column label="商品名称"   align="center"> </el-table-column>
                    <el-table-column label="规格型号"   align="center"> </el-table-column>
                    <el-table-column label="申报数量"   align="center"> </el-table-column>
                    <el-table-column label="申报单价"   align="center"> </el-table-column>
                    <el-table-column label="申报总价"   align="center"> </el-table-column>
                    <el-table-column label="申报币制"   align="center"> </el-table-column>
                    <el-table-column label="申报计量单位" width="120"  align="center"> </el-table-column>
                    <el-table-column label="法定计量单位" width="120" align="center"> </el-table-column>
                    <el-table-column label="法定第二计量单位" width="120" align="center"> </el-table-column>
                    <el-table-column label="原产国(地区)" width="120" align="center"> </el-table-column>
                    <el-table-column label="最终目的国(地区)" width="120" align="center"> </el-table-column>
                    <el-table-column label="法定数量"   align="center"> </el-table-column>
                    <el-table-column label="第二法定数量" width="120" align="center"> </el-table-column>
                    <el-table-column label="检验检疫编码" width="120"  align="center"> </el-table-column>
                    <el-table-column label="商品英文名称"  width="120" align="center"> </el-table-column>
                    <el-table-column label="原产地区代码"  width="120" align="center"> </el-table-column>
                    <el-table-column label="用途代码"   align="center"> </el-table-column>
                    <el-table-column label="产品有效期"   align="center"> </el-table-column>
                    <el-table-column label="产品保质期"   align="center"> </el-table-column>
                    <el-table-column label="货物属性代码"  width="120" align="center"> </el-table-column>
                    <el-table-column label="成份/原料/组份"  width="120" align="center"> </el-table-column>
                    <el-table-column label="UN编码"   align="center"> </el-table-column>
                    <el-table-column label="危险货物名称"  width="120" align="center"> </el-table-column>
                    <el-table-column label="危包类别"   align="center"> </el-table-column>
                    <el-table-column label="危包规格"   align="center"> </el-table-column>
                    <el-table-column label="境外生产企业名称"  width="120" align="center"> </el-table-column>
                    <el-table-column label="非危险化学品"  width="120" align="center"> </el-table-column>
                    <el-table-column label="目的地代码"   align="center"> </el-table-column>
                    <el-table-column label="检验检疫货物规格" width="120"  align="center"> </el-table-column>
                    <el-table-column label="货物型号"   align="center"> </el-table-column>
                    <el-table-column label="货物品牌"   align="center"> </el-table-column>
                    <el-table-column label="生产日期"   align="center"> </el-table-column>
                    <el-table-column label="生产批号"   align="center"> </el-table-column>
                    <el-table-column label="境内目的地/境内货源地" width="150" align="center"> </el-table-column>
                    <el-table-column label="检验检疫名称" width="120" align="center"> </el-table-column>
                    <el-table-column label="生产单位注册号" width="120" align="center"> </el-table-column>
                    <el-table-column label="生产单位名称" width="120" align="center"> </el-table-column>
                </el-table>
                <div class="top_flex" style="margin-top: 5px;">
                    <div >
                    </div>
                    <el-button type="primary" icon="el-icon-download" size="mini">导入报关单表头、表体其他字段</el-button>
                </div>
                <el-divider content-position="left"><span>报关单表头其他字段</span></el-divider>
                <el-form class="form_declare" label-width="125px" size="mini" >
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="提单号" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="合同号">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="征免性质" >
                                <el-select :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="成交方式" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="单据类型" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="运费币制" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="运费标记">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="运费/率" >
                                <el-select :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="毛重" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="净重" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="保险费币制" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="保险费标记">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="保险费/率" >
                                <el-select :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="包装种类" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="件数" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="杂费币制" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="杂费标志">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="杂费/率" >
                                <el-select :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="许可证编号" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="承诺事项" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="贸易国别" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="启运港代码">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="经停港/指运港" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="存放地点" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="运输工具代码及名称" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="入境/离境口岸代码">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="境外发货人代码" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="境外发货人名称(外文)" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="境外收发货人名称" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="境外收发货人地址">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="境外收货人编码" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="境外收货人名称(外文)" >
                                <el-input :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="随附单据">
                <el-form class="form_declare" label-width="140px" size="mini" >
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="业务单证类型" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="业务单证统一编号">
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="上传人IC卡号" >
                                <el-select :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="变更/修改次数" >
                                <el-input  :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="随附单据格式">
                                <el-input  class="yellow"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="随附单据类型" >
                                <el-select ></el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="随附单据编号" >
                                <el-input ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="随附单据所属单位">
                                <el-input ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="随附单据所属单位名称" >
                                <el-select :disabled="true"></el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="清单商品序号" >
                                <el-input></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="随附单据文件">
                                <div class="top_flex" style="height: 28px;">
                                    <div >
                                        <el-button type="primary" icon="el-icon-upload2" size="mini">文件选择</el-button>
                                        <span class="upload_text">注意：选择文件后，请先点击下方“暂存”按钮再点击“上传”按钮。</span>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="tipBox">
                    <span>提醒：</span>
                    <span>1、附件大小要求不超过4M，如果文件过大，建议拆分多个上传；</span>
                    <span> 2、附件格式要求：PDF文件；</span>
                    <span> 3、同一附件类型可以上传多个附件；</span>
                    <span>4、附件传输过程中会出现传输失败的情况，请随时关注附件传输状态；</span>
                    <span>5、要求上传复印件的可上传原件的扫描件。</span>
                </div>
                <div class="top_flex">
                    <div>
                        <el-button icon="el-icon-plus" size="mini">新增</el-button>
                        <el-button icon="el-icon-document-remove" size="mini">暂存</el-button>
                        <el-button icon="el-icon-delete" size="mini">删除</el-button>
                        <el-button icon="el-icon-upload2" size="mini" >上传</el-button>
                        <el-button icon="el-icon-download" size="mini" >下载</el-button>
                        <el-button icon="el-icon-document-remove" size="mini" >预览</el-button>
                    </div>
                </div>
                <el-table style="width: 100%;" size="mini" height="300px" highlight-current-row  :header-cell-style="{'text-align':'center'}">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="随附单据序号" > </el-table-column>
                    <el-table-column label="随附单据文件名称" align="center"> </el-table-column>
                    <el-table-column label="随附单据类型"  align="center"> </el-table-column>
                    <el-table-column label="随附单据编号"  align="center"> </el-table-column>
                    <el-table-column label="随附单据状态" align="center"> </el-table-column>
                    <el-table-column label="清单商品序号" align="center"> </el-table-column>
                    <el-table-column label="随附单据所属单位" align="center"> </el-table-column>
                    <el-table-column label="上传人IC卡号" align="center"> </el-table-column>
                    <el-table-column label="随附单据存储名" align="center"> </el-table-column>
                    <el-table-column label="随附单据格式" align="center"> </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <!-- 商品列表 -->
        <el-dialog v-dialogDrag title="商品列表" :visible.sync="goodsShow" width="60%"  :close-on-click-modal="false" :before-close="goodsClose" >
            <span>从商品归类表中查询到了下列商品，请选择：</span>
            <el-table ref="goosListTable" :data="goodsList" highlight-current-row @current-change="goodsChange" max-height="400px">
                <el-table-column property="hsCode" label="商品编码" width="120"></el-table-column>
                <el-table-column property="hsName" label="商品名称" width="200"></el-table-column>
                <el-table-column property="hsUnit" label="计量单位" width="120"></el-table-column>
                <el-table-column property="hsDes" label="备注"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="sureGoods">确 定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>
<script>
import AEODec from '@/config/AEODec.js'
import AEObasicData from '@/config/AEObasicData.js'
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate } from "../../../utils/reports/grwebapp";
export default {
    components:{
    },
    props: {
        exportCode: {
            type: String,
            default: ''
        },
    },
    watch: {
        exportCode: {
            handler(newVal,oldVal) {
                if(newVal === 'E'){
                    this.invtHeadType.impexpMarkcd = 'E'
                }else if (newVal === 'I'){
                    this.invtHeadType.impexpMarkcd = 'I'
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        },
        'invtListType.dclUnitQty':{
            handler(newVal,oldVal) {
                if(newVal){
                    if(this.invtListType.dclUprcAmt !== ''){
                        this.invtListType.dclTotalAmt = Number(this.invtListType.dclUnitQty) * Number(this.invtListType.dclUprcAmt)
                        this.invtListType.dclTotalAmt = Number(this.invtListType.dclTotalAmt).toFixed(2)
                    }
                }
            }
        },
        'invtListType.dclUprcAmt':{
            handler(newVal,oldVal) {
                if(newVal){
                    if(this.invtListType.dclUnitQty !== ''){
                        this.invtListType.dclTotalAmt = Number(this.invtListType.dclUnitQty) * Number(this.invtListType.dclUprcAmt)
                        this.invtListType.dclTotalAmt = Number(this.invtListType.dclTotalAmt).toFixed(2)
                    }
                }
            }
        },
        invtList:{
            handler(newVal,oldVal) {
                if(newVal.length){
                    this.tipsTotal.dclTotalAmt = 0 // 申报总价
                    this.tipsTotal.dclUnitQty = 0 // 申报数量
                    this.tipsTotal.lawfUnitQty = 0 // 法定第一数量
                    this.tipsTotal.secdLawfUnit = 0 // 法定第二数量
                    this.tipsTotal.grossWt = 0 // 毛重
                    this.tipsTotal.netWt = 0 // 净重
                    newVal.forEach(item => {
                        this.tipsTotal.dclTotalAmt += Number(item.dclTotalAmt) ? Number(item.dclTotalAmt) : 0 //申报总价
                        this.tipsTotal.dclUnitQty += Number(item.dclUnitQty) ? Number(item.dclUnitQty) : 0 // 申报数量
                        this.tipsTotal.lawfUnitQty += Number(item.lawfUnitQty) ? Number(item.lawfUnitQty) : 0 // 法定第一数量
                        this.tipsTotal.secdLawfUnit += Number(item.secdLawfUnit) ? Number(item.secdLawfUnit) : 0 // 法定第二数量
                        this.tipsTotal.grossWt += Number(item.grossWt) ? Number(item.grossWt) : 0 // 毛重
                        this.tipsTotal.netWt += Number(item.netWt) ? Number(item.netWt) : 0 // 净重
                    });
                    this.tipsTotal.dclTotalAmt = Number(this.tipsTotal.dclTotalAmt).toFixed(2) //申报总价
                    this.tipsTotal.dclUnitQty = Number(this.tipsTotal.dclUnitQty).toFixed(2) // 申报数量
                    this.tipsTotal.lawfUnitQty =  Number(this.tipsTotal.lawfUnitQty).toFixed(2) // 法定第一数量
                    this.tipsTotal.secdLawfUnit = Number(this.tipsTotal.secdLawfUnit).toFixed(2) // 法定第二数量
                    this.tipsTotal.grossWt = Number(this.tipsTotal.grossWt).toFixed(2) // 毛重
                    this.tipsTotal.netWt = Number(this.tipsTotal.netWt).toFixed(2)
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    data() {
        return {
            localStorageName:localStorage.getItem('name'),// 当前登录人名称
            invtHeadType:AEODec.invtHeadType, // 表头
            invtHeadTypeRules:AEODec.invtHeadTypeRules, // 表头验证规则
            invtListType:JSON.parse(JSON.stringify(AEODec.invtListType)),// 表体
            invtListTypeRules:AEODec.invtListTypeRules, // 表体验证规则
            invtList:[],// 商品表格
            selectGoosd:{}, // 商品选中信息
            billTYPE:AEObasicData.INVT_BILL_TYPE, // 清单类型
            declareTYPE:AEObasicData.INVT_DECLARE_TYPE, //申报类型
            mtpckEndprdTYPE:AEObasicData.INVT_MtpckEndprd_TYPE, // 料件、成品标志	
            superviseList:AEObasicData.CUS_MAPPING_TRADE_CODE_V, // 监管方式/贸易方式
            transportModeList:AEObasicData.CUS_MAPPING_TRANSPORT_CODE_V,//运输方式
            customsList:[], //海关列表
            countryList:[], // 国家
            listTypeList:AEObasicData.INVT_list_TYPE, // 流转类型
            dclcusFlagList:AEObasicData.INVT_DCLCUS_FLAG,// 是否报关
            gendecFlagList:AEObasicData.INVT_GENDEC_FLAG,// 是否生成报关单
            decTypeList:AEObasicData.INVT_decTYPE_TYPE,// 报关单类型
            dclcusTypeList:AEObasicData.INVT_dclcus_TYPE,// 报关类型
            currencyList: AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制
            unitList: [], // 计量单位列表
            dutyModeList:AEObasicData.CUS_LEVYMODE, // 征免方式
            trueORfalse:AEObasicData.trueORfalse, // 是/否
            enterpriseList:[], // 企业列表
            goodsList:[], // 查询商品列表
            goodsShow:false, // 商品弹窗显示
            goodsDetailsVal:{}, // 选中商品信息
            tipsTotal:{
                dclTotalAmt:'', // 申报总价
                dclUnitQty:'', // 申报数量
                lawfUnitQty:'', // 法定第一数量
                secdLawfUnit:'', // 法定第二数量
                grossWt:'', // 毛重
                netWt:'', // 净重
            }, // 表体汇总
            modfMarkcdList: AEObasicData.MODF_MARKCD_TYPE,   // 修改标志
            inputCode:false, // 禁止编辑页面标志
        }
    },
    mounted() {
        // 获取当天日期
        const today = new Date(); 
        const year = today.getFullYear();  
        const month = String(today.getMonth() + 1).padStart(2, '0');  
        const day = String(today.getDate()).padStart(2, '0'); 
        this.invtHeadType.inputTime = `${year}${month}${day}`;
    },
    methods: {
        // 如果有id则回显
        getdeclareDetails(id,ifCopy){ // ifCopy 是否是复制,是复制新建的话清除id
            if(id){
                this.$api.getInvBy(id).then(res => { 
                    this.invtHeadType = res.invHead
                    this.invtList = res.invList
                    this.invtListType.gdsSeqNo = res.invList.length + 1
                    this.invtHeadType.dclEtpsNo = '37026800AT' // 申报单位编码
                    this.invtHeadType.dclEtpsSccd = '913702205611551766' // 申报单位社会信用代码
                    this.invtHeadType.dclEtpsNm = '青岛菲尔斯特物流有限公司' // 申报单位名称
                    if(!ifCopy){
                        // 不是复制新建
                    }else{
                        // 是复制新建
                        this.invtHeadType.id = ''
                        this.invtHeadType.createTime = ''
                        this.invtHeadType.modifyDate = null
                        this.invtHeadType.seqNo = ''
                        this.invtHeadType.inputerName = ''
                        this.invtHeadType.checker = ''
                        this.invtHeadType.declareDate = null
                        this.invtHeadType.invtNo = ''
                        this.invtHeadType.etpsInnerInvtNo = ''
                        // 表体清除id
                        this.invtList.map(item =>{
                            item.id = ''
                            item.interId = ''
                            return{...item}
                        })
                    }
                    // 进境关别 / 主管海关
                    this.customsList = AEObasicData.CUS_CUSTOMS.filter(item =>
                        item.codeValue.toLowerCase().includes(res.invHead.impexpPortcd.toLowerCase()) ||
                        item.codeValue.toLowerCase().includes(res.invHead.dclPlcCuscd.toLowerCase()) 
                    )
                    // 启运国
                    this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                        item.cusCode.toLowerCase().includes(res.invHead.stshipTrsarvNatcd.toLowerCase())
                    )
                })
            }else{
                const initialData = this.$options.data.call(this); // 获取初始数据
                Object.keys(initialData).forEach(key => {
                    this[key] = initialData[key]; // 逐字段重置
                });
                this.$forceUpdate()
                this.$refs.invtHeadType.resetFields();
            }
        },
        // 过滤国家列表
        getCustomsList(value){
            if(value && value !== ' '){
                this.customsList = AEObasicData.CUS_CUSTOMS.filter(item =>
                    item.codeName.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeValue.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤国家地区
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤计量单位
        getUnitList(value){
            if(value && value !== ' '){
                this.unitList = AEObasicData.CUS_UNIT.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 获取企业列表
        getEnterpriseList(value){
            this.$api.getCompanyList(  {companyName:value } ).then(res =>{
                this.enterpriseList = res.tableData
            })
        },
        // 企业名称可选可填
        selectBlur(e,code) {
            if (e.target.value !== '') {
                if(code === 'bizopEtpsNm'){
                    this.invtHeadType.bizopEtpsNm = e.target.value;
                }else if(code === 'rcvgdEtpsNm'){
                    this.invtHeadType.rcvgdEtpsNm = e.target.value;
                }else if(code === 'dclEtpsNm'){
                    this.invtHeadType.dclEtpsNm = e.target.value;
                }else if(code === 'rltEntryBizopEtpsNm'){
                    this.invtHeadType.rltEntryBizopEtpsNm = e.target.value
                }else if(code === 'rltEntryRcvgdEtpsNm'){
                    this.invtHeadType.rltEntryRcvgdEtpsNm = e.target.value
                }else if(code === 'rltEntryDclEtpsNm'){
                    this.invtHeadType.rltEntryDclEtpsNm = e.target.value
                }
                this.$forceUpdate();   // 强制更新
            }
        },
        // 选择后列表置空
        emptyList(value,code){
            if(code === 'impexpPortcd'){ // 进境关别
                this.invtHeadType.impexpPortcd = value
                this.customsList = []
            }else if(code === 'dclPlcCuscd'){// 主管海关
                this.invtHeadType.dclPlcCuscd = value
                this.customsList = []
            }else if(code === 'stshipTrsarvNatcd'){
                this.invtHeadType.stshipTrsarvNatcd = value
                this.countryList = []
            }else if(code === 'dclUnit'){ // 计量单位
                this.invtListType.dclUnit = value
                this.unitList = []
            }else if(code === 'natcd'){// 原产国
                this.invtListType.natcd = value
                this.countryList = []
            }else if(code === 'destinationNat'){ // 最终目的国
                this.invtListType.destinationNat = value
                this.countryList = []
            }
        },
        // 选择企业后带出海关编码和信用代码
        enterpriseChange(value,code){
            const item  = value.split('-')
            if(code === 'bizopEtpsNm'){
                this.invtHeadType.bizopEtpsNm = item[0]
                this.invtHeadType.bizopEtpsNo = item[1]
                this.invtHeadType.bizopEtpsSccd = item[2]
            }else if(code === 'rcvgdEtpsNm'){
                this.invtHeadType.rcvgdEtpsNm = item[0]
                this.invtHeadType.rcvgdEtpsNo = item[1]
                this.invtHeadType.rvsngdEtpsSccd = item[2]
            }else if( code === 'dclEtpsNm'){
                this.invtHeadType.dclEtpsNm = item[0]
                this.invtHeadType.dclEtpsNo = item[1]
                this.invtHeadType.dclEtpsSccd = item[2]
            }else if(code === 'rltEntryBizopEtpsNm'){
                this.invtHeadType.rltEntryBizopEtpsNm = item[0]
                this.invtHeadType.rltEntryBizopEtpsno = item[1]
                this.invtHeadType.rltEntryBizopEtpsSccd = item[2]
            }else if(code === 'rltEntryRcvgdEtpsNm'){
                this.invtHeadType.rltEntryRcvgdEtpsNm = item[0]
                this.invtHeadType.rltEntryRcvgdEtpsno = item[1]
                this.invtHeadType.rltEntryRvsngdEtpsSccd = item[2]
            }else if(code === 'rltEntryDclEtpsNm'){
                this.invtHeadType.rltEntryDclEtpsNm = item[0]
                this.invtHeadType.rltEntryDclEtpsno = item[1]
                this.invtHeadType.rltEntryDclEtpsSccd = item[2]
            }
            this.enterpriseList = []
        },
        // 选择报关类型
        dclcusTypecdSelect(value){
            if(value === '2'){
                this.invtHeadType.corrEntryDclEtpsNo = '37026800AT'
                this.invtHeadType.corrEntryDclEtpsSccd = '913702205611551766'
                this.invtHeadType.corrEntryDclEtpsNm = '青岛菲尔斯特物流有限公司'
            }else if(value === '1'){
                this.invtHeadType.corrEntryDclEtpsNo = ''
                this.invtHeadType.corrEntryDclEtpsSccd = ''
                this.invtHeadType.corrEntryDclEtpsNm = ''
            }
        },
        // 输入商品编号后回车
        goodsCodeEnter(){
            if( this.invtListType.gdeCd && this.invtListType.gdeCd !== ' ' ){
                // 查询商品
                this.$api.getGoodsBy(  this.invtListType.gdeCd  ).then(res =>{
                    this.goodsList = res
                    this.goodsShow = true
                    // 默认选中第一个
                    this.$refs.goosListTable.setCurrentRow(this.goodsList[0]);
                })
            }
        },
        // 选中商品时
        goodsChange(val){
            this.goodsDetailsVal = val
        },
        // 确认选中商品时
        sureGoods() {
            this.invtListType.goodsCodeEnter = this.goodsDetailsVal.hsCode
            this.invtListType.gdsNm = this.goodsDetailsVal.hsName
            // 检测商品计量单位有几个
            if (this.goodsDetailsVal.hsUnit.indexOf('/') !== -1) {
                // 有/，复制法一法二
                const lawfUnitCode = AEObasicData.CUS_UNIT.filter(item =>
                    item.codeName.toLowerCase().includes(this.goodsDetailsVal.hsUnit.split('/')[0])
                );
                const secdLawfUnitCode = AEObasicData.CUS_UNIT.filter(item =>
                    item.codeName.toLowerCase().includes(this.goodsDetailsVal.hsUnit.split('/')[1])
                );
                this.invtListType.lawfUnit = lawfUnitCode[0].codeValue
                this.invtListType.secdLawfUnit = secdLawfUnitCode[0].codeValue
                this.unitList.push(lawfUnitCode[0])
                this.unitList.push(secdLawfUnitCode[0])
            } else {
                const lawfUnitCode = AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(this.goodsDetailsVal.hsUnit)
                    );
                this.invtListType.lawfUnit = lawfUnitCode[0].codeValue
                this.invtListType.secdLawfUnit = ''
                this.unitList.push(lawfUnitCode[0])
            }
            this.goodsClose()
        },
        // 关闭商品列表弹窗
        goodsClose(){
            this.goodsShow = false
            this.goodsList = [],
            this.goodsDetailsVal = {}
        },
        // 备注回车添加到表格中
        addGoosdList(){
            this.$refs.invtListType.validate((valid) => {
                if (valid) {
                    var item = JSON.parse(JSON.stringify(this.invtListType))
                    // 判断是修改还是新增
                    if(this.invtList.length >= this.invtListType.gdsSeqNo){
                        // 修改
                        const updataNum = item.gdsSeqNo - 1
                        this.$set(this.invtList, updataNum , item);
                    }else{
                        // 新增
                        this.invtList.push(item)
                    }
                    this.invtListType = JSON.parse(JSON.stringify(AEODec.invtListType))
                    this.invtListType.gdsSeqNo = this.invtList.length + 1
                    this.$message({
                        message: '添加/修改成功',
                        type: 'success'
                    });
                }else {
                    this.$message({
                        message: '请填写必填项',
                        type: 'warning'
                    });
                    return false;
                }
            })
        },
        // 选中表格中数据回显
        goodsDetailsShow(val){
            if(val){
                this.invtListType = JSON.parse(JSON.stringify(val))
                this.selectGoosd = JSON.parse(JSON.stringify(val))
                // 查询计量单位，法一，最终目的国，原产国
                this.unitList = AEObasicData.CUS_UNIT.filter(item =>
                    item.codeValue.toLowerCase().includes(this.invtListType.dclUnit.toLowerCase()) ||
                    item.codeValue.toLowerCase().includes(this.invtListType.lawfUnit.toLowerCase())
                );
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.cusCode.toLowerCase().includes(this.invtListType.natcd.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(this.invtListType.destinationNat.toLowerCase())
                );
            }
        },
        // 商品列表新增一行
        addGoodsList(){
            // 取消表格选中
            this.selectGoosd = {}
            this.$refs.invtList.setCurrentRow() // 取消高亮
            this.invtListType = JSON.parse(JSON.stringify(AEODec.invtListType))
            this.invtListType.gdsSeqNo = this.invtList.length +1
        },
        // 删除所选商品列表
        deleteGoodsDetails(){
            if(this.selectGoosd.gdsSeqNo){
                this.$confirm('是否确认删除商品表体数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const index = this.selectGoosd.gdsSeqNo-1
                    this.invtList.splice(index, 1)
                    // 重新排序
                    this.tableGNoSort()
                    // 商品新增一行
                    this.addGoodsList()
                }).catch(() => {
                    return false          
                });
            }else{
                this.$message({
                    message: '请先选中数据!',
                    type: 'warning'
                });
            }
        },
        // 复制选中商品
        copyGoods(){
            if(this.selectGoosd.gdsSeqNo){
                this.selectGoosd.gdsSeqNo  = this.invtList.length + 1
                const item = JSON.parse(JSON.stringify(this.selectGoosd))
                this.invtList.push(item)
                // 清空选中数据
                this.selectGoosd = {}
                this.$refs.invtList.setCurrentRow()
            }else{
                this.$message({
                    message: '请先选中数据!',
                    type: 'warning'
                });
            }
        },
        // 商品表格数据重新排序
        tableGNoSort(){
            this.invtList.forEach((item, index) => {
                item.gdsSeqNo = index + 1;
            });
        },
        // 新建或复制新建一单
        copyDeclare(iscopy){
            var submenuLabel = ''
            var submenuPath = ''
            var submenuName = ''
            if(this.exportCode === 'E'){ // 出口
                submenuLabel = '出口保税核注'
                submenuPath = '/invtExport'
                submenuName = 'invtExport'
            }else if(this.exportCode ==='I'){ // 进口
                submenuLabel = '进口保税核注'
                submenuPath = '/invtImport'
                submenuName = 'invtImport'
            }
            this.$store.commit('addKeepAliveCache', submenuName)
            var submenu = {
                path: submenuPath,
                name: submenuName,
                label: submenuLabel,
            }
            //修改选中菜单
            this.$store.commit('selectMenu', submenu)
            this.$router.push({ path: submenuPath })
            if(iscopy){
                this.$eventBus.$emit('data-invtID', { id: this.invtHeadType.id })
            }
        },
        // 暂存
        temporarilySave(iftemporarily){ // 先判断是不是暂存
            if(iftemporarily){ // 是暂存
                var params = {}
                params.invHead = this.invtHeadType
                params.invList = this.invtList
                this.$api.saveInvInfo( params ).then(res =>{
                    this.getdeclareDetails(res,false)
                    this.$message({
                        message: '暂存成功',
                        type: 'success'
                    });
                })
            }else{
                // 复审
                this.$refs.invtHeadType.validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确认提交复审', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {   
                            const params = {}
                            params.invHead = this.invtHeadType
                            params.invList = this.invtList
                            this.$api.saveInvInfo( params ).then(res =>{
                                this.getdeclareDetails(res,false)
                                this.$message({
                                    message: '提交复审成功',
                                    type: 'success'
                                });
                            })
                        }).catch(() => {});
                    }else {
                        this.$message({
                            message: '请填写完整数据',
                            type: 'warning'
                        });
                        return false;
                    }
                })
            }

        },
        // 申报
        declareInvt(){
            // 判断预录人和当前人是否是一个人，是则不允许申报
            if(this.invtHeadType.inputerName === this.localStorageName ){
                this.$message({
                    message: '预录人与审核人不能是一个人！',
                    type: 'warning'
                });
                return false;
            }
            this.$refs.invtHeadType.validate((valid) => {
                if (valid) {
                    this.$confirm('是否确认提交申报', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {   
                        const params = {}
                        params.invHead = this.invtHeadType
                        params.invList = this.invtList
                        this.$api.declareInvXml( params ).then(res =>{
                            this.getdeclareDetails(this.invtHeadType.id,false)
                            this.$message({
                                message: '提交申报成功',
                                type: 'success'
                            });
                        })
                    }).catch(() => {});
                }else {
                    this.$message({
                        message: '请填写完整数据',
                        type: 'warning'
                    });
                    return false;
                }
            })
        },
        // 删除
        deleteInvInfo(){
            this.$confirm('是否确认删除此核注清单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {   
                this.$api.deleteInvInfo( this.invtHeadType.id ).then(res =>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // 跳转页面并关闭当前页面
                    // 历史选中菜单
                    var oldActivePath = this.$store.state.activePath
                    // 历史已选中菜单列表
                    var oldTabList = this.$store.state.tabList
                    const index = oldTabList.findIndex(item => item.name === oldActivePath);
                    if (index !== -1) {
                        oldTabList.splice(index, 1);
                    }
                    // 同时存储菜单
                    this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
                    // 删除keepAlive缓存
                    this.$store.commit('removeKeepAliveCache', oldActivePath)
                    var submenuPath = ''
                    var submenuName = ''
                    var submenuLabel = ''
                    if(this.exportCode === 'E'){
                        submenuLabel = '出口保税核注'
                        submenuPath = '/invtExport'
                        submenuName = 'invtExport'
                    }else{
                        submenuLabel = '进口保税核注'
                        submenuPath = '/invtImport'
                        submenuName = 'invtImport'
                    }
                    this.$store.commit('addKeepAliveCache', submenuName)
                    var submenu = {
                        path: submenuPath,
                        name: submenuName,
                        label: submenuLabel,
                    }
                    //修改选中菜单
                    this.$store.commit('selectMenu', submenu)
                    this.$router.push({ path:submenuPath })
                })
            }).catch(() => {});

        },
        // 打印
        report(){
            var reportURL = ''
            if(this.invtHeadType.dclcusTypecd === '1'){
                reportURL = '/grf/invtDeclare_1.grf'
            }else{
                reportURL = '/grf/invtDeclare_2.grf'
            }
            var master = JSON.parse(JSON.stringify(this.invtHeadType)) 
            if(this.exportCode === 'E'){
                // 出口
                master.invtTitle = '出口' 
                master.impexpPortcdName = '出境关别'
                master.stshipTrsarvNatcdName = '运抵国(地区)'
            }else {
                // 进口
                master.invtTitle = '进口' 
                master.impexpPortcdName = '进境关别'
                master.stshipTrsarvNatcdName = '启运国(地区)'

            }
            master.invtType = this.$refs['invtTypeText'].query.split("-")[1] // 清单类型
            master.impexpPortcd = this.$refs['impexpPortcdText'].query.split("-")[1] // 进、出境关别
            master.dclPlcCuscd = this.$refs['dclPlcCuscdText'].query.split("-")[1] // 主管海关
            master.stshipTrsarvNatcd = this.$refs['stshipTrsarvNatcdText'].query.split("-")[1] // 运抵国、启运国
            master.mtpckEndprdMarkcd = this.$refs['mtpckEndprdMarkcdText'].query.split("-")[1] // 料件、成品标志
            master.supvModecd = this.$refs['supvModecdText'].query.split("-")[1] // 监管方式
            master.trspModecd = this.$refs['trspModecdText'].query.split("-")[1] // 运输方式
            master.dclcusFlag = this.$refs['dclcusFlagText'].query.split("-")[1] // 报关标志
            master.dclcusTypecd = this.$refs['dclcusTypecdText'].query.split("-")[1] // 报关类型
            master.decType = this.$refs['decTypeText'].query.split("-")[1] // 报关单类型
            master.listType = this.$refs['listTypeText'].query.split("-")[1] // 流转类型
            var table = JSON.parse(JSON.stringify(this.invtList))
            table.forEach(item => {
                item.natcd = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem => 
                    aeoitem.cusCode.toLowerCase().includes(item.natcd.toLowerCase())
                )[0].codeName // 原产国(地区)
                item.destinationNat = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem => 
                    aeoitem.cusCode.toLowerCase().includes(item.destinationNat.toLowerCase())
                )[0].codeName // 最终目的国(地区)
                item.dclUnit = AEObasicData.CUS_UNIT.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.dclUnit.toLowerCase())
                )[0].codeName // 申报计量单位
                item.dclCurr = AEObasicData.CUS_MAPPING_CURRENCY_CODE_V.filter(aeoitem => 
                    aeoitem.cusCode.toLowerCase().includes(item.dclCurr.toLowerCase())
                )[0].codeName // 币制
                item.lawfUnit = item.lawfUnit !== '' ? AEObasicData.CUS_UNIT.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.lawfUnit.toLowerCase())
                )[0].codeName :'' // 法定计量单位
                item.secdLawfUnit = item.secdLawfUnit !== '' ? AEObasicData.CUS_UNIT.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.secdLawfUnit.toLowerCase())
                )[0].codeName :'' // 法定第二计量单位
                item.lvyrlfModecd = AEObasicData.CUS_LEVYMODE.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.lvyrlfModecd.toLowerCase())
                )[0].codeName // 征免方式
                item.clyMark = item.clyMark !== '' ? AEObasicData.trueORfalse.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.clyMark.toLowerCase())
                )[0].codeName :'' // 危化品标志
            })
            const params = { master:master,table:table }
            var args = {
                report: urlAddRandomNo(reportURL),
                data: params,
                type: "preview",
                FontEmbedding: true,  //指定嵌入字体数据
            };
            webapp_ws_ajax_run(args);
        }
    }
        
}
</script>
<style lang="css" scoped>
.nameInput{
    margin: 0px 10px;
    font-size: 14px;
}
.margin_5{
    margin: 0px 5px;
}
/* 选中表格高亮 */
::v-deep .el-table__body tr.current-row>td.el-table__cell{
    background-color: #ffc7ff !important;
}
.width_100{
    width: 100%;
}
.margin_top_10{
    margin-top: 10px;
}
.margin_right_20{
    margin-right: 20px;
}
.top_flex{
    margin: 0px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.top_flex .el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
/* 标签页 */
::v-deep .el-tabs__item {
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
}
.form_declare{
    width: auto;
    margin-top: 10px;
}
/* 输入框黄色 */
::v-deep .yellow .el-input__inner {
    background-color: #FAFFBD;
}
/* 表单边距 */
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: -1px;
}
::v-deep .el-col{
    padding-left: 5px !important;
    padding-right:5px !important;
}
::v-deep .el-form-item__label{
    padding: 0 5px 0 0;
}
/* 表单字体 */
::v-deep .el-form-item__label {
    font-size: 12px;
}
/* 表体汇总 */
.summaryText{
    width: 100%;
    font-size: 13px;
    color:#de1f92;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 5px;
}
.summaryText span{
    background-color: lemonchiffon;
}
/* 分割线 */
::v-deep .el-divider__text{
    font-size: 12px;
    color: red;
    font-weight:400;
}
::v-deep .el-divider__text span{
    color:#309be6;
}
::v-deep .el-divider--horizontal{
    margin: 12px 0;
}
/* 随附单据提示文字 */
.upload_text{
    font-size: 13px;
    margin-left: 40px;
    color:#a94442;
}
/* 随附单据提示框 */
.tipBox{
    width: auto;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    margin: 5px 1px;
    border-radius: 0px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    font-size: 13px;
}
.omitText{
    display: -webkit-box;
    -webkit-line-clamp: 2;    /* 限制显示行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
